import { Injectable } from '@angular/core';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

@Injectable({ providedIn: 'root' })
export class PdfGeneratorService {
  async generatePdfFromElement(element: HTMLElement): Promise<Blob> {
    if (!element) {
      throw new Error('LR template element not found');
    }

    // Ensure element is in the DOM and visible enough for html2canvas
    const originalDisplay = element.style.display;
    const originalOpacity = element.style.opacity;

    element.style.display = 'block';
    element.style.opacity = '1';

    // Give it a tick to layout (optional, but safer)
    await Promise.resolve();

    const canvas = await html2canvas(element, {
      scale: 3, // ⬅️ Increase resolution
      useCORS: true,
      logging: false,
    });

    // restore original styles
    element.style.display = originalDisplay;
    element.style.opacity = originalOpacity;

    if (!canvas || canvas.width === 0 || canvas.height === 0) {
      throw new Error(
        'Canvas is empty, check that the LR template is not display:none'
      );
    }

    // Force JPEG to avoid UNKNOWN type issues
    const imgData = canvas.toDataURL('image/jpeg', 1.0);
    if (!imgData.startsWith('data:image')) {
      throw new Error('Generated data URL is not an image');
    }

    const pdf = new jsPDF('p', 'mm', 'a4');

    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);

    return pdf.output('blob');
  }
}
